export enum BannerTypeEnum {
  HOME_BANNER = 1, //首页banner
  TOOLS_BANNER = 2, //工作台banner
  RECHARGE_CENTER = 3, //充值中心banner
}
// 支付货币类型
export enum CurrencysEnum {
  USD = 'USD', // 美元
  CNY = 'CNY', // 人民币
  TWD = 'TWD', // 新台币
  MYR = 'MYR', // 林吉特
}
export enum AgentRoleEnum {
  MAIN = 1, // 普通用户,主站用户,无任何推广返佣
  // AGENT = 2, // 代理商
  DEALER = 3, // 经销商
}
export enum IsThirdServiceEnum {
  ThirdService = 2, // 三方服务
  PLATFORM = 1, //平台
  ALL = 3, // 所有
}
export enum BannerPlatformEnum {
  WEB = 1,
  MOBILE = 2,
}
// 是否开启智能客服
export enum OnLineServiceStatusEnum {
  OPEN = 1,
  CLOSE = 2,
}
// 首页banner底下的卡片
export enum SmallBannerEnumOptionsEnum {
  DIGITAL_WORKBENCH = 0, //数字人工作台
  AI_TOOL = 1, //ai工具
  DIGITAL_ASSETS = 2, //数字资产
  INTERACTIVE_DIGITAL_PERSON = 3, // 交互数字人
  EXCELLENT_CASE = 4, //优秀案例
}
export enum FirstLoginEnum {
  EMAIL = 0, //邮箱登陆
  PHONE = 1, //手机验证码登陆
  WX = 2, //微信登陆
}
export enum Lang {
  LAN_CN = 'zh',
  LAN_EN = 'en',
  LAN_TW = 'zh-tw',
}
export enum DiscountCodeTypeEnum {
  DISCOUNT_CODE = 1, // 折扣码
  INVITE_CODE = 2, // 邀请码
}
export enum RouterTypeEnum {
  ADMIN = 1, // 后端路由
  TOOL = 2, // 前端路由
  WEB = 3, // 静态网页路由
}
// 任务状态
export enum GlobalStateEnum {
  NEED_VERIFY = -3, // 需要审核
  // 队列满了,等待加入队列
  Waiting = -2,
  // 已经提交,等待回调
  WaitingBack = -1,
  // 任务正在执行
  Pending = 0,
  Success = 1,
  Fail = 2,
  // 过期时间
  EXPIRED = 3,
  ALL = 10,
}
export enum ThemeEnum {
  DEFAULT = 'default',
  GREEN = 'green',
  VOLCANO = 'volcano',
  PINK = 'pink',
  MINGQING = 'mingQing',
  LIGHT = 'light',
  DUSK = 'dusk',
  AURORA_GREEN = 'auroraGreen',
  SAUCE_PURPLE = 'saucePurple',
  SKY_BLUE = 'skyBlue',
  RUBY = 'ruby',
  AMBER = 'amber',
  EMERALD = 'emerald',
  INDIGO = 'indigo',
  CORAL = 'coral',
  LAVENDER = 'lavender',
  TURQUOISE = 'turquoise',
  LIME = 'lime',
  BRONZE = 'bronze',
  SLATE = 'slate',
  ROYAL_BLUE = 'royalBlue',
  VIOLET = 'violet',
  SUNSET = 'sunset',
  MINT = 'mint',
  ROSE = 'rose',
  AQUA = 'aqua',
  COFFEE = 'coffee',
  MATCHA = 'matcha',
  BURGUNDY = 'burgundy',
  SILVER = 'silver',
  CRIMSON = 'crimson',
  SCARLET = 'scarlet',
  CHERRY = 'cherry',
  RUST = 'rust',
  WINE = 'wine',
  GOLD = 'gold',
  NAVY = 'navy',
  FOREST = 'forest',
  PLUM = 'plum',
  CHARCOAL = 'charcoal',
  PEACH = 'peach',
  AZURE = 'azure',
  PERSIMMON = 'persimmon',
  IRIS = 'iris',
  MANGO = 'mango',
}
/**
 * 没有用到
 */
export enum GradientStartColorsEnum {
  BLUE = 'blue',
  GREEN = 'green',
  PURPLE = 'purple',
  ORANGE = 'orange',
  PINK = 'pink',
  TEAL = 'teal',
  RED = 'red',
  RUBY = 'ruby',
  AMBER = 'amber',
  EMERALD = 'emerald',
  INDIGO = 'indigo',
  CORAL = 'coral',
  LAVENDER = 'lavender',
  TURQUOISE = 'turquoise',
  LIME = 'lime',
  BRONZE = 'bronze',
  SLATE = 'slate',
  ROYAL_BLUE = 'royalBlue',
  VIOLET = 'violet',
  SUNSET = 'sunset',
  MINT = 'mint',
  ROSE = 'rose',
  AQUA = 'aqua',
  COFFEE = 'coffee',
  MATCHA = 'matcha',
  BURGUNDY = 'burgundy',
  SILVER = 'silver',
  CRIMSON = 'crimson',
  SCARLET = 'scarlet',
  CHERRY = 'cherry',
  RUST = 'rust',
  WINE = 'wine',
  GOLD = 'gold',
  NAVY = 'navy',
  FOREST = 'forest',
  PLUM = 'plum',
  CHARCOAL = 'charcoal',
  PEACH = 'peach',
  AZURE = 'azure',
  PERSIMMON = 'persimmon',
  IRIS = 'iris',
  MANGO = 'mango',
}
export enum systemEnum {
  COMMON_CFG_KEY = 'system-commonConfig',
  PORTAL_CFG_KEY = 'system-portalConfig',
  LOCALE_KEY = 'current-lang',
  THEME_KEY = 'current-theme',
}
//首页下滑的内容
export enum SwiperSortingOptionsEnum {
  ENTERPRISE_INTELLIGENCE_TRANSFORMATION = 0, // 从AI人才培养到企业智能转型
  AIGC_SAAS_CLOUD_PLATFORM = 1, // aigc-saas云平台
  DIGITAL_HUMAN_LIVE_STREAMING_OPERATIOn = 2, //  数字人直播运营
  INTELLIGENT_AGENT_DEVELOPMENT = 3, //智能体开发
  EXECUTION_STANDARDS = 4, //执行工信人才培养标准
  NATIONAL_OPERATION_CENTER_COVERAGE = 5, // 全国运营中心覆盖
  INDUSTRY_PARTNER_SUPPORT = 6, //产业合作伙伴支持
  CONSULT_NOW = 7, //立即联系
  DIGITAL_HUMAN_APPLICATION_SCENARIOS = 8, //数字人应用场景
}
